import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { supabase } from './supabase';

import Landing from './pages/Landing';
import Taster from './pages/Taster';
import Auth from './pages/Auth';
import Subscribe from './pages/Subscribe';
import Studio from './pages/Studio';
import Account from './pages/Account';
import Terms from './pages/Terms';

export default function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check current session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setLoading(false);
    });

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });

    return () => subscription.unsubscribe();
  }, []);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#0d0a08', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ color: '#c9a96e', fontFamily: 'serif', fontSize: '18px', opacity: 0.6 }}>Loading…</div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing user={user} />} />
<Route path="/taster" element={<Taster />} />

        <Route path="/auth" element={<Auth user={user} />} />
        <Route path="/subscribe" element={<Subscribe user={user} />} />
        <Route path="/studio" element={user ? <Studio user={user} /> : <Navigate to="/auth" />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/account" element={user ? <Account user={user} /> : <Navigate to="/auth" />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </BrowserRouter>
  );
}

